import {useEffect, useState} from 'react';
import {ValidationProcess, ValidationProcessCompleted,} from './pages';

import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {AppContainer} from './style';
import initI18n from './utils/initI18n';

const App = () => {
  const [isValidationPage, setIsValidationPage] = useState<boolean>(false);
  const [isValidationCompletePage, setIsValidationCompletePage] = useState<boolean>(false);
  const [ready, setReady] = useState(false);

  const redirectOrStay = async () => {
    if (window.location.pathname === '/validationprocess') {
      setIsValidationPage(true);
    }
    if (window.location.pathname === '/validationprocesscomplete') {
      setIsValidationCompletePage(true);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await initI18n();
      } catch (error) {
        console.error();
      } finally {
        setReady(true);
        redirectOrStay();
      }
    };
    init();
  }, []);

  return ready ? (
    <BrowserRouter>
      <AppContainer>

        {isValidationPage ? (
            <Routes>
              <Route
                path="/validationprocess"
                element={<ValidationProcess/>}
              />
            </Routes>
          ) :
          isValidationCompletePage ? (
            <Routes>
              <Route
                path="/validationprocesscomplete"
                element={<ValidationProcessCompleted/>}
              />
            </Routes>
          ) : (
            <>
            </>
          )}
      </AppContainer>
    </BrowserRouter>
  ) : null;
};

export default App;
